import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';
import type { CategoryDto } from '../types';

export const useCategories = (projectUuid?: string) => {
  return useQuery<CategoryDto[]>({
    queryKey: ['categories', projectUuid],
    queryFn: () => apiClient.get(`/v1/projects/${projectUuid}/categories`),
    enabled: !!projectUuid,
  });
};
